<!--面包屑组件-->
<template>
    <div id="bread">
        <el-breadcrumb separator="·">
        <el-breadcrumb-item class="test">当前位置： </el-breadcrumb-item>
        <el-breadcrumb-item class="test" v-for="(item,index) in content" :key="index" :to="{name:`${item.routerName}`}">
            {{item.text}}
        </el-breadcrumb-item>
        </el-breadcrumb>
    </div>
</template>
<script>
export default {
  name: "bread",
  props: {
    /*[{text:'首页',routerName:'index'}] */
    content: {
      type: Array
    }
  },
  mounted() {
    document.querySelector('#bread .el-breadcrumb__separator').hidden = true
  }
}
</script>
<style lang="scss">
#bread {
  span {
    font-size: 18px;
    opacity: 0.75;
    font-family: "Arial Normal", "Arial";
    font-weight: 400;
    font-style: normal;
    color: #000000;
  }
}
</style>


